/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 */
import React from "react";
import BuildingDetailsApp from "../Functionality/BuildingDetailsApp";
import DivContainerBody from "../../../components/DivContainerBody";
import HeadTittle from "../../../components/HeadTittle";
import routes from "../../../Routes/routes";
import BuildingInformation from "./BuildingInformation";
import BuildingDetailsMainTabs from "./BuildingDetailsMainTabs";
import VerifiedUnverifiedUsersModal from "./VerifiedUnverifiedUsersModal";

const BuildingDetails = () => {
    const {
        t,
        buildingDetail,
        setModified,
        showManagerUserListModal,
        setShowManagerUserListModal,
        userClassificationSelected,
        setUserClassificationSelected,
        containerRef,
        containerHeight
    } = BuildingDetailsApp();


    return (
        <>
            <HeadTittle name={t('details')} link={routes.building.list} hidden={false} />

            <DivContainerBody>
                <div className={"row mb-4 minh-645px"} ref={containerRef}>
                    <div className='col-sm-12 col-md-6 col-lg-5 col-xl-4 mb-4 minh-645px' style={{height:containerHeight }}>
                        <BuildingInformation
                            t={t}
                            buildingDetail={buildingDetail}
                            setUserClassificationSelected={setUserClassificationSelected}
                            setShowManagerUserListModal={setShowManagerUserListModal}
                            containerHeight={containerHeight}
                        />
                    </div>
                    <div className='col-sm-12 col-md-6 col-lg-7 col-xl-8 mb-4 minh-645px' style={{height:containerHeight }}>
                        <BuildingDetailsMainTabs
                            t={t}
                            buildingDetail={buildingDetail}
                            setModified={setModified}
                            containerHeight={containerHeight}
                        />
                    </div>
                </div>
            </DivContainerBody>

            {showManagerUserListModal && (
                <VerifiedUnverifiedUsersModal
                    show={showManagerUserListModal}
                    onHide={() => setShowManagerUserListModal(false)}
                    buildingId={buildingDetail?.id}
                    userClassificationSelected={userClassificationSelected}
                />
            )}
        </>
    );
};

export default BuildingDetails;
